import { render, staticRenderFns } from "./toBe.vue?vue&type=template&id=4ccadb5b&scoped=true&"
import script from "./toBe.vue?vue&type=script&lang=js&"
export * from "./toBe.vue?vue&type=script&lang=js&"
import style0 from "./toBe.vue?vue&type=style&index=0&id=4ccadb5b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ccadb5b",
  null
  
)

export default component.exports